import { SelectionItem } from '../../../domain/selectionItem'
import { PushSmall } from '../Push/PushSmall'
import { sortProductMediaGalleryByRoles } from '../../utils/Product.utils'
import { ROLE_FOCUS, ROLE_SMALL } from '../../utils/media.utils'

type SelectionItemProps = {
  className?: string
  item: SelectionItem
  hideColorVariations?: boolean
  keepOnlyOneImage?: boolean
  position?: number
  isHome?: boolean
  listId?: string
  listName?: string
}

const ListSelectionItem = ({
  item,
  className,
  hideColorVariations = false,
  keepOnlyOneImage = false,
  position,
  isHome = false,
  listId = '',
  listName = '',
}: SelectionItemProps) => {
  const images =
    (item.mediaGallery &&
      sortProductMediaGalleryByRoles(item.mediaGallery, [ROLE_SMALL, ROLE_FOCUS])) ||
    []

  return (
    <PushSmall
      id={item.id}
      mediaGallery={keepOnlyOneImage && images.length > 0 ? [images[0]] : images}
      name={item.name}
      gtm_name={item.gtm_name}
      isLoading={item.stockStatus === 'Loading'}
      title={item.title}
      titleDescription={item.titleDescription}
      priceRange={item.priceRange || item.price_range}
      urlKey={item.urlKey}
      parentClassNameList={className}
      colorVariations={!hideColorVariations ? item.colorVariations : undefined}
      isExcluWeb={item.isExcluWeb}
      isNew={item.isNew}
      isIconique={item.isIconique}
      isFineJewelry={item.isFineJewelry}
      enVente={item.enVente}
      typename={item.typename}
      customPrice={item.customPrice}
      mariage={item.mariage}
      gtm_categories={item?.gtm_categories ?? item.categoriesOfProduct?.label}
      couleurMetalExtended={item.couleurMetalExtended}
      position={position}
      sku={item.sku}
      isHome={isHome}
      listId={listId}
      listName={listName}
    />
  )
}

export default ListSelectionItem
